import { render } from "./TokenomicsPage.vue?vue&type=template&id=068c16f4"
import script from "./TokenomicsPage.vue?vue&type=script&lang=js"
export * from "./TokenomicsPage.vue?vue&type=script&lang=js"

import "./TokenomicsPage.vue?vue&type=style&index=0&id=068c16f4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__